import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, UserCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function ProfileButton() {
  const [showMenu, setShowMenu] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        {currentUser?.photoBase64 ? (
          <img
            src={currentUser.photoBase64}
            alt="Foto de perfil"
            className="h-8 w-8 rounded-full object-cover border border-gray-200"
          />
        ) : (
          <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
            <User className="h-5 w-5 text-gray-600" />
          </div>
        )}
      </button>

      {showMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 border border-gray-100">
          <button
            onClick={() => {
              navigate('/dashboard/profile');
              setShowMenu(false);
            }}
            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 w-full"
          >
            <UserCircle size={16} />
            <span>Ver meu perfil</span>
          </button>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 w-full"
          >
            <LogOut size={16} />
            <span>Terminar Sessão</span>
          </button>
        </div>
      )}
    </div>
  );
}
